module.exports = __webpack_public_path__ + "static/media/bussiness-background-png.23c9bfc1.webp";